export default {
  title: '! Bestellungen pausiert bis {{time}}',
  button: 'Forsetzen',
  labels: {
    rest_of_day: 'Rest des Tages',
  },
};
